const DEFAULT_VERSION = 'latest';
export const VERSION = typeof "3.2.10" !== 'undefined' ? "3.2.10" : DEFAULT_VERSION;

if (typeof "3.2.10" === 'undefined') {
  console.error('loaders.gl: The __VERSION__ variable is not injected using babel plugin. Latest unstable workers would be fetched from the CDN.');
}
//# sourceMappingURL=version.js.map